<template>
  <b-form @submit.prevent="onPromptSubmit">
    <div class="position-relative mb-3">
      <div class="search-input-container">
        <textarea-autosize
          :value="value"
          :min-height="100"
          @input="$emit('input', $event)"
          rows="1"
          class="search-input"
          placeholder="Type your question here or pick from an example"
          :autosize="true"
          v-autofocus="true"
          ref="textarea"
          @keydown.native.enter="onEnter"
        />
      </div>
      <save-button
        btn-text="Go AI"
        submit-btn-class="px-4 ask-btn"
        :is-loading="isLoading"
        :is-submit-disabled="isLoading"
        :disabled="!value"
        type="submit"
      />
    </div>
    <search-helps class="mt-4" :on-prompt-selection="onPromptSelection" v-if="!isPrompted" />
  </b-form>
</template>

<script>
import SaveButton from '@/components/SaveButton.vue'
import SearchHelps from '@/components/templates/SearchHelps.vue'
import { LoadingState } from '@/constants/common'
import { BForm } from 'bootstrap-vue'
import TextareaAutosize from 'vue-textarea-autosize/src/components/TextareaAutosize.vue'

/**
 * This provides a textarea and a submit button. Textarea supports resizing based on content.
 */
export default {
  name: 'SearchBar',
  props: ['loadingState', 'value', 'isPrompted'],
  components: {
    SearchHelps,
    BForm,
    SaveButton,
    TextareaAutosize
  },
  data() {
    return {}
  },
  computed: {
    isLoading() {
      return this.loadingState === LoadingState.LOADING
    }
  },
  methods: {
    onPromptSubmit() {
      !this.isLoading && this.$emit('submit')
    },
    onEnter(event) {
      if (!event.shiftKey) {
        this.onPromptSubmit()
        event.preventDefault()
      }
    },
    focusTextArea() {
      this.$refs.textarea.$el.focus()
    },
    /*
    this function is getting used  by parent component
     */
    selectTextArea() {
      this.$refs.textarea.$el.focus({ behavior: 'smooth' })
      this.$refs.textarea.$el.select()
    },
    /*
    this function is getting used  by parent component
     */
    onPromptSelection(prompt) {
      this.$emit('input', prompt)
      this.focusTextArea()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.search-input-container {
  box-shadow: 0px 1px 15px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  width: 100%;
  overflow: hidden;

  .search-input {
    padding: 16px 102px 16px 16px;
    border: none;
    width: 100%;
    &:focus {
      border: none;
      outline: none;
    }
    caret-color: $brand;
  }
}
/deep/ .ask-btn {
  position: absolute;
  right: 16px;
  bottom: 19px;
  margin-right: 0px !important;
}
</style>
